import { ShiftState } from 'src/types/redux';
import {
  SHIFT_FAILURE,
  SHIFT_REQUEST,
  SHIFT_SUCCESS,
  ShiftActionType,
} from '../types/shiftType';

const initialState: ShiftState = {
  error: '',
  loading: false,
  shiftData: null,
};

export const shiftReducer = (
  state = initialState,
  action: ShiftActionType
): ShiftState => {
  switch (action?.type) {
    case SHIFT_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case SHIFT_SUCCESS:
      return {
        ...state,
        loading: false,
        shiftData: action?.payload,
      };
    case SHIFT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action?.payload,
      };
    default:
      return state;
  }
};
